export const URLBILLETERA = 'https://usuario.bitnovaworld.com/'